"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = makeStyles_1.default(() => ({
    underline: {
        borderBottomColor: '#cdcdcd',
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
    },
    spacing: {
        marginTop: 2,
        marginBottom: 2,
    },
    labelRoot: {
        color: '#333',
        display: 'flex',
        justifyContent: 'flex-end',
    },
    labelError: {
        color: '#CD5360',
    },
    labelText: {
        textAlign: 'right',
        lineHeight: '22px',
    },
    labelDisabled: {
        color: '#333 !important',
    },
    labelBold: {
        fontWeight: 700,
    },
    labelItalic: {
        fontStyle: 'italic',
    },
    boxRoot: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginRight: '8px',
    },
    boxError: {
        color: '#CD5360',
    },
}));
//# sourceMappingURL=form-field-wrapper-styles.js.map